import React, {useCallback, useContext} from 'react';
import {ToggleButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/ToggleButton/ToggleButton';

import './TextFormatCasingBase.sass';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {useSelector} from 'react-redux';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const TextFormatCasingBase = ({active, onClick, dataQaId, label, value}) => {
  const {activeObjects} = useContext(EventCreateContext);
  const editorDisabled = useSelector(selectEditorDisabled);
  const onClickHandler = useCallback(
    (checked) => {
      onClick(checked ? value : null);
    },
    [onClick, value]
  );

  return (
    <ToggleButton onChange={onClickHandler} active={active}>
      <button
        data-qa-id={dataQaId}
        className={`unstyled-button text_format_casing_base ${
          active ? 'text_format_casing_base--checked' : ''
        }`}
        disabled={editorDisabled}
      >
        {label}
      </button>
    </ToggleButton>
  );
};
